import api from './api';

export const settingsService = {
    // Verify subscription code
    verifySubscriptionCode: async (code) => {
        const response = await api.post('/paiement/verifyCode', { code });
        return response.data;
    },

    // Submit report
    submitReport: async (reportData) => {
        const response = await api.post('/report/submit', reportData);
        return response.data;
    },

    // Programmer la suppression définitive du compte dans 30 jours
    requestAccountDeletion: async () => {
        const response = await api.delete('/user/me');
        return response.data;
    },

    // Réactiver un compte pendant le délai de rétractation
    cancelAccountDeletion: async () => {
        const response = await api.post('/user/me/deletion/cancel');
        return response.data;
    }
};

export default settingsService;
